import { AccountsFilter, ResponseError } from "@shared/interfaces";
import { Invoice } from "@shared/models/Invoice";
import {
  Account,
  AccountAttempts,
  AccountPropertyList,
  AccountNote,
  Feature,
  Subscription,
  AccountScmManager,
} from "@shared/models";

export enum AccountError {
  checkPaymentMethodExistenceError = "checkPaymentMethodExistenceError",
  getInvoicesError = "getInvoicesError",
  payInvoiceError = "payInvoiceError",
  getAccountsError = "getAccountsError",
  getAccountsListError = "getAccountsListError",
  getAccountPropertyListsError = "getAccountPropertyListsError",
  createAccountPropertyListError = "createAccountPropertyList",
  getAccountNotesError = "getAccountNotesError",
  createAccountNoteError = "createAccountNoteError",
  getAccountAttemptsError = "getAccountAttemptsError",
  saveAccountAttemptsError = "saveAccountAttemptsError",
  linkAccountPropertyListToPropertiesFromFileError = "linkAccountPropertyListToPropertiesFromFile",
  getAccountError = "getAccountError",
  createAccount = "createAccount",
  updateAccount = "updateAccount",
  deleteAccount = "deleteAccount",
  accountPaymentError = "accountPaymentError",
}

export interface AccountCheckType {
  chargebeeId?: string | null;
  hubspotId?: string | null;
  flikId?: string | null;
  isChargebeeIdValid?: boolean;
  isHubspotIdValid?: boolean;
  isFlikIdValid?: boolean;
  hubspotMessage?: string;
  flikIdMessage?: string;
}

export interface AccountStateType {
  scmManager: AccountScmManager | null;
  paymentMethodExists: boolean | null;
  cardPaymentMethodExists: boolean | null;
  invoices: Invoice[] | null;
  paidInvoiceId: number | null;
  accounts: Account[];
  accountsTotal: number;
  accountsFilter: AccountsFilter;
  accountsList: { list: Account[]; total: number } | null;
  accountsListFilter: AccountsFilter;
  selectedAccount: Account | null;
  features: Feature[];
  accountPayment:
    | {
        id: number;
        status: string;
      }
    | undefined;
  subscriptions: Subscription[];
  accountPropertyList: AccountPropertyList | null;
  accountPropertyLists: AccountPropertyList[] | null;
  accountNotes: { [type: string]: { [id: string | number]: AccountNote[] } };
  accountAttempts: { [type: string]: { [id: string | number]: AccountAttempts } };
  errors: {
    [key in AccountError]: ResponseError | null;
  };
  accountCheck: AccountCheckType;
  selectedSubscription: Subscription | null;
  activeAccount: Account | null;
}
